"use client";

import React from "react";
import Animate from "@/components/animations/Animate";
import Logo from "@/components/media/Logo";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import { DesktopNav, MobileNav } from "./parts";
import { useHeader } from "./provider";
import type { HeaderProps } from "./types";

function Header({ className, ...props }: HeaderProps) {
  const { headerRef, isVisible } = useHeader();
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Animate.Presence mode="wait">
      {isVisible && (
        <Animate
          as="header"
          variant="fadeInTop"
          ref={headerRef}
          className={cn(
            "fixed top-0 right-0 left-0 z-30 shadow-lg",
            "bg-background border border-border border-b-1",
            "~p-2/8",
            className,
            classes,
          )}
          {...native}
        >
          <nav
            className="w-full h-full flex flex-row justify-between items-center"
            aria-label="main-navigation"
          >
            <Logo />

            <DesktopNav />
            <MobileNav />
          </nav>
        </Animate>
      )}
    </Animate.Presence>
  );
}

export default Header;
